import { render, staticRenderFns } from "./MFAViewActivatedFeedback.vue?vue&type=template&id=d79db468"
import script from "./MFAViewActivatedFeedback.vue?vue&type=script&lang=ts"
export * from "./MFAViewActivatedFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports